export const LikedVideos = () => {
    return (
        <div>
            <h1 className="text-3xl text-slate-100 font-bold">Liked Videos</h1>
        </div>
    )
}